module.exports = __webpack_public_path__ + "static/media/mojomar.8626f83b.webp";